import isAnObject from '@/helpers/isAnObject'

export default function (obj) {
  if (!isAnObject(obj)) return ''
  let st = ''
  for (const key of Object.keys(obj)) {
    st += `${key}: ${obj[key]}, `
  }
  return st
}
